module.exports = __webpack_public_path__ + "static/media/YB5M16_2.4e067365.jpg";